import { SET_OPERATORS } from '../types';

export const setOperators = (data) => (dispatch) => {
  dispatch({
    type: SET_OPERATORS,
    payload: data,
  });
};
